export default __webpack_public_path__ + "static/media/JAHNUS.09671d50.png";